import { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import Product from './components/Product';
import Price from './components/Price';
import Faq from './components/Faq';
import Cta from './components/Cta';
import Footer from './components/Footer';
import Access from './components/Access';
import AuthOptions from './components/AuthOptions';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';

// TODO: Create and import these components
// import Home from "./pages/Home";
// import ErrorPage from "./pages/ErrorPage";

function App() {
  const location = useLocation();
  const [isMainPage, setIsMainPage] = useState(location.pathname === '/');
  const showHeaderFooter = ![
    '/access',
    '/auth',
    '/login',
    '/signup',
    '/forgot-password',
  ].includes(location.pathname);

  // Function to get canonical URL based on current route
  const getCanonicalUrl = () => {
    const baseUrl = 'https://appointdoc.com'; // TODO: Replace with your actual domain
    if (location.pathname === '/') {
      return baseUrl;
    }
    return `${baseUrl}${location.pathname}`;
  };

  useEffect(() => {
    setIsMainPage(location.pathname === '/');

    // Handle URL parameters and hash navigation
    const searchParams = new URLSearchParams(location.search);
    const scrollTarget = searchParams.get('scrollTo');

    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else if (scrollTarget) {
      const element = document.getElementById(scrollTarget);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen">
        <Helmet>
          <link rel="canonical" href={getCanonicalUrl()} />
          <meta property="og:url" content={getCanonicalUrl()} />
          <meta name="twitter:url" content={getCanonicalUrl()} />
        </Helmet>

        {showHeaderFooter && (
          <div className="w-full bg-base-100">
            <Header />
          </div>
        )}

        <main className="flex-1 w-full">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <Stats />
                  <Features />
                  <Product />
                  <Price />
                  <Faq />
                  <Cta />
                </>
              }
            />
            <Route path="/access" element={<Access />} />
            <Route path="/auth" element={<AuthOptions />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="*" element={<div>404 - Page Not Found</div>} />
          </Routes>
        </main>

        {showHeaderFooter && (
          <div className="w-full bg-base-100">
            <Footer />
          </div>
        )}
      </div>
    </HelmetProvider>
  );
}

export default App;
